<div class="form-group">
  @if (props.label) {
    <label>{{ props.label }}</label>
  }
  @if (props.template) {
    <div [class]="props.className" [innerHtml]="props.template"></div>
  }

  @if (props.tooltip) {
    <div class="template-tooltip float-right">
      <app-tooltip [title]="props.tooltip.title" [tooltip]="props.tooltip.message"></app-tooltip>
    </div>
  }
</div>
